import { render, staticRenderFns } from "./ServicosOmie.vue?vue&type=template&id=801c590c"
import script from "./ServicosOmie.vue?vue&type=script&lang=js"
export * from "./ServicosOmie.vue?vue&type=script&lang=js"
import style0 from "./ServicosOmie.vue?vue&type=style&index=0&id=801c590c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports